//cannot contain Dates, functions, Infinity, RegExps, Maps, Sets, Blobs, FileLists, ImageDatas, sparse Arrays, Typed Arrays or other complex types
import meta from '../../data/metaData';
export default {
  language: "en",
  languageSelector: {isShow: false},
  ws: undefined,
};
